import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Country List Data
export const fetchCountryList = createAsyncThunk(
  "country/fetchCountryList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/location/panel/CountryList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Country to the List
export const addCountryList = createAsyncThunk(
  "country/addCountryList",
  async (newCountryData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/CountryList", newCountryData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      console.log(error.message);
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Country List Data
export const updateCountryList = createAsyncThunk(
  "country/updateCountryList",
  async (countryData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/CountryList", countryData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Country List Slice
const countryListSlice = createSlice({
  name: "country",
  initialState: {
    countryList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Country List
      .addCase(fetchCountryList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCountryList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.countryList = action.payload;
      })
      .addCase(fetchCountryList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Country
      .addCase(addCountryList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCountryList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addCountryList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Country List
      .addCase(updateCountryList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateCountryList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateCountryList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = countryListSlice.actions;

export default countryListSlice.reducer;
